import { App, URLOpenListenerEvent } from '@capacitor/app';
import React, { useEffect } from 'react';
import { useHistory } from '../../hooks/useRouterCompat';
import { My } from '../My';


// https://capacitorjs.com/docs/guides/deep-links
const AppUrlListener: React.FC<any> = () => {
  let history = useHistory();

  useEffect(() => {
    const unsub = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      console.log("Triggered App.addListener('appUrlOpen'...)", event.url);
      let slug = '';
      if (event.url.includes('.nextpod.jp')) {
        slug = event.url.split('.nextpod.jp').pop() || '';
      } else {
        try {
          const urlObj = new URL(event.url);
          slug = urlObj.pathname + urlObj.search + urlObj.hash;
        } catch (e) {
          console.warn('[AppUrlListener] Parse error', e);
        }
      }

      // 방어 코드: slug가 여전히 스킴(://)을 포함하면 앱 웹뷰 오류가 발생하므로 차단
      if (slug && !slug.includes('://')) {
        if (!slug.startsWith('/')) {
            slug = '/' + slug;
        }

        if (My.isLoggedIn()) {
          history.push(slug);
        }
        else {
          window.location.href = slug;
        }
      }
    });
    return () => {
      // console.log("Removed App.addListener('appUrlOpen'...")
      // unsub?.remove();
    }
  }, []);

  return null;
};

export default AppUrlListener;